import * as React from 'react';
import { Tab } from '@alifd/next';
import SliderImage from './slider-image';
import SliderList from './slider-list';
import ImageZoom from './image-zoom';
import doLog from '../../common/log';
import * as classnames from "classnames";

const { useState } = React;

interface PropTypes {
  data: any;
  visibleId: number;
  tabIndex: number;
  setSliderIndex: any
  i18n: any;
}

interface ZoomProps {
  scale: number
  enableBigger: boolean
  enableSmaller: boolean
}
function SliderTab ( props: PropTypes ) {
  const { data,i18n,visibleId,tabIndex,setSliderIndex } = props;
  const [activedId,setactivedId] = useState( visibleId );
  const [imageZoom,setImageZoom] = useState<ZoomProps>( {
    scale: 1,
    enableBigger: true,
    enableSmaller: false,
  } )
  const cls = classnames( {
    "image-layout": true,
    "certification": Object.keys( data )[tabIndex] === 'Test Report'
      || Object.keys( data )[tabIndex] === 'Certification'
  } );

  return (
    <Tab
      defaultActiveKey={`${tabIndex}`}
      className="tab-list"
      unmountInactiveTabs={true}
      onChange={( n: string ) => {
        doLog(
          '/sc.details.commonLogs',
          `action=mainImageDialogTabClick&info=${n}`
        );
        setSliderIndex( {
          tabIndex: parseInt( n,10 ),
          visibleId: 0
        } )
        setactivedId( 0 );
      }}
    >
      {Object.keys( data ).map( ( item,index ) => (
        <Tab.Item
          title={item}
          key={index}
        >
          <div className={cls}>
            <SliderImage
              mediaItems={data[item]}
              activedId={activedId}
              imageZoom={imageZoom}
              handleChange={n => {
                setImageZoom( {
                  scale: 1,
                  enableBigger: true,
                  enableSmaller: false,
                } )
                setactivedId( n );
              }}
            />
            <SliderList
              mediaItems={data[item]}
              activedId={activedId}
              handleClick={n => {
                setImageZoom( {
                  scale: 1,
                  enableBigger: true,
                  enableSmaller: false,
                } )
                setactivedId( n );
              }}
            />
            {data[item][activedId]?.type !== 'video' && <ImageZoom imageZoom={imageZoom} setImageZoom={setImageZoom} />}
          </div>
        </Tab.Item>
      ) )}
    </Tab>
  );
}

export default SliderTab;
